import PropTypes from 'prop-types';
import React from 'react';
import FormattedTranslation from 'components/Common/FormattedTranslationMui';
import { Button } from '@mui/material';
import SuccessMessage from 'components/Common/Messages/SuccessMessage';

export const LinkLoginResult = ({ onRetry }) => (
  <>
    <SuccessMessage outlined={false}>
      <FormattedTranslation id="page.login.linkLogin.success" />
    </SuccessMessage>
    <Button fullWidth onClick={onRetry}>
      <FormattedTranslation id="page.login.linkLogin.retry" />
    </Button>
  </>
);

LinkLoginResult.propTypes = {
  onRetry: PropTypes.func.isRequired,
};

export default LinkLoginResult;
